import React from "react";
import useProfileDetailsForm from "../hooks/useProfileDetailsForm";
import { FormLabel, FormRow } from "../../../../components/ui/form";
import { Input } from "../../../../components/ui/input";
import { CardFooter } from "../../../../components/ui/card";
import { Button } from "../../../../components/ui/button";

interface ProfileDetailsFormProps { }

const ProfileDetailsForm = (props: ProfileDetailsFormProps) => {
    const {
        dirty,
        errors,
        formData,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        isValid,
        touched,
        resetForm
    } = useProfileDetailsForm();

    return (
        <form className="form" onSubmit={handleSubmit} noValidate>
            <h4 className="fw-bolder text-dark mb-6">Profile Details</h4>

            {/* First Name & Last Name Row */}

            <FormRow>
                <div className="d-flex flex-column w-50">
                    <FormLabel required>First Name</FormLabel>
                    <Input
                        name="firstName"
                        placeholder="First name"
                        value={formData.firstName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.firstName}
                        error={errors.firstName}
                    />
                </div>
                <div className="d-flex flex-column w-50">
                    <FormLabel required>Last Name</FormLabel>
                    <Input
                        name="lastName"
                        placeholder="Last name"
                        value={formData.lastName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.lastName}
                        error={errors.lastName}
                    />
                </div>
            </FormRow>

            {/* Email Row */}
            {/* <div className="row mb-6">
                <div className="col-lg-12">
                    <label className="col-form-label required fw-bold fs-6">Email</label>
                    <input
                        type="email"
                        name="email"
                        className={`form-control form-control-lg form-control-solid ${touched.email && errors.email ? "is-invalid" : ""
                            }`}
                        placeholder="Email address"
                        value={formData.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    />
                    {touched.email && errors.email && (
                        <div className="invalid-feedback">{errors.email}</div>
                    )}
                </div>
            </div> */}

            {/* Save Profile Button */}
            <CardFooter className="justify-content-start px-0">
                <Button
                    disabled={!dirty || isSubmitting}
                    variant="light"
                    onClick={() => resetForm()}
                    type='button'>
                    Discard
                </Button>
                <Button
                    disabled={!dirty || !isValid || isSubmitting}
                    variant="primary"
                    type='submit'
                    isLoading={isSubmitting}>
                    Save
                </Button>
            </CardFooter>
        </form >
    );
};

export default ProfileDetailsForm;